import React from 'react';
import { useEffect, useState } from 'react';
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/confirm-sr-details.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Checkbox from '../common/ui-components/input/Checkbox';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
    changeProgress,
    updateWhatsappCheck,
    updateSuccessData,
    updateFailureData,
    updateTempSrId,
    changeTrackerState,
    restoreFromTicketList,
} from '../../redux/actions/selfserveActions';
import { CreateTicket, GetSlotAvailabilityData } from '../../api/selfserve';
import { srPayLoad, slotApiPayload, parseSlotAvailabilityData, isTempSrRequired, isCopaymentRequired, addAppRenderParams } from '../../utils/selfserve';
import Moment from 'moment';
import { confirmDetails } from '../../tracking/selfserveTracking';
import { useRouter } from 'next/router';
import { HOMECARE_PLAN_LIST } from '../../constants/index';
import EraseSRListAlert from './EraseSRListModal';
import ConfirmDeleteDeviceModel from './ConfirmDeleteDeviceModel';
import File from '@/components/UI/File';
import { cleverTapTrigger } from '../../tracking/segment';
import { isCopayAfterSr } from '../../utils/selfserve';

interface ReduxStateProps {
    selfserveReducer: any,
}


interface MainProps {

    setPageLoading: (data:Boolean) => void
}

type Props = ReduxStateProps & MainProps;

const ConfirmSrDetails = (props: Props) => {

    const dispatch:any = useDispatch()
    const router = useRouter()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {

        dispatch(changeTrackerState(3));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});

    }, [])

    // Whatsapp CheckBox
    const [whatsappOptIn, changeWhatsappOptIn] = React.useState<boolean>(props.selfserveReducer.whatsAppOptIn);
    const [slotsAvailable, setSlotsAvailable] = useState<boolean>(true);
    const [slotErrorText, setSlotErrorText] = useState<string>('');

    // Whatsapp check handler
    const handleWhatsapp = () => {
        dispatch(updateWhatsappCheck(!whatsappOptIn));
        changeWhatsappOptIn(!whatsappOptIn);
    }

    const [showAlert, toggleAlert] = React.useState<boolean>(false)
    const [deleteDeviceKey, setDeleteDeviceKey] = useState<String>('');
    const [isOpenDeviceDeleteModel, setIsOpenDeviceDeleteModel] = useState(false);

    const handleEditOption = (step, osid:any=null) => {
        if (osid) {
          dispatch(restoreFromTicketList(osid))
        }
        dispatch(changeProgress(step))
    }

    const createSrPayLoad = (data, temp_sr, whatsapp) => {
        if(HOMECARE_PLAN_LIST.includes(props.selfserveReducer.parentPlanDetails.plan_name)) {
          // make sure the current ticket is pushed before returning
          let srPayloadList : any = [];
          let ticketKeys = Object.keys(props.selfserveReducer.ticket_list);
          ticketKeys.forEach(key => {
            srPayloadList.push(srPayLoad({...props.selfserveReducer.ticket_list[key], customerDetails:props.selfserveReducer.customerDetails, appointmentProcessType:props.selfserveReducer.appointmentProcessType}, temp_sr=temp_sr, whatsapp));
          });
          return {ticket_list:srPayloadList};
        }
        return srPayLoad(data,temp_sr=temp_sr, whatsapp);
    }

    // Create Ticket API call Function
    const creatSR: any = (step) => {

        props.setPageLoading(true);
        const selectedCover = props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0]
        // accessing the same varaible with unpacking
        const {is_copay: isCopayPlan, plan_name: planName} = props.selfserveReducer.planDetails   
        let isTempSr = isTempSrRequired(isCopayPlan, selectedCover.reopen, selectedCover.cover_title,
                                        props.selfserveReducer.planDetails.plan_name,
                                        selectedCover.is_cover_copay);
        const postData:any = createSrPayLoad(props.selfserveReducer, isTempSr, whatsappOptIn);
        let payload = {
            "application": "website",
            "data": postData
        }
        if(HOMECARE_PLAN_LIST.includes(props.selfserveReducer.parentPlanDetails.plan_name)) {
          payload['is_multiple'] = true;
        }
        CreateTicket(payload).then((res:any) => {
            if (res.data.is_valid){

                dispatch(updateSuccessData(res.data))
                dispatch(updateTempSrId({index:0, onsite_sr_id: res.data.onsitego_temp_sr_id}))

                if(step !== undefined) {

                    dispatch(changeProgress(step));
                    props.setPageLoading(false);
                    setLoading(false);
                } else {
                    dispatch(changeProgress(10));
                    cleverTapTrigger('Raise SR Success', {'osid':props.selfserveReducer?.planDetails?.osid, 'ref_no':res.data?.data.ticket_creation_ref_id, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
                    props.setPageLoading(false);
                    setLoading(false);
                }

            }else if(res.data.sr_details) {
                dispatch(updateSuccessData(res.data))
                dispatch(changeProgress(17));
                props.setPageLoading(false);
                setLoading(false);
            }else {

                dispatch(updateFailureData(res.data));
                dispatch(changeProgress(11));
                cleverTapTrigger('Raise SR Failure', {'osid':props.selfserveReducer?.planDetails?.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
                props.setPageLoading(false);
                setLoading(false);

            }
        }).catch(() => {
          addAppRenderParams(router)
        })
    }

    const handleButton = (e) => {

        setLoading(true);
        e.preventDefault();
        const selectedCover = props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0]
        const {is_copay: isCopayPlan, plan_name: planName} = props.selfserveReducer.planDetails 
        const isCopayRequired = isCopaymentRequired(isCopayPlan, selectedCover.reopen, selectedCover.cover_title,
                                                    planName, selectedCover.is_cover_copay);

        if(['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType) && !HOMECARE_PLAN_LIST.includes(props.selfserveReducer.parentPlanDetails.plan_name)){
            const appointmentData = props.selfserveReducer.appointmentProcessType
            const data = slotApiPayload(props.selfserveReducer)
            GetSlotAvailabilityData(data).then((res: any) => {
                if(res?.response?.ok){
                    let { dateSlotMapping } = parseSlotAvailabilityData(res.data)
                    let selectedTimeSlot1 = appointmentData.appointmentTimeSlot1
                    let selectedDate1 = Moment(appointmentData.appointmentDate1, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    let isSlotAvailable1 = dateSlotMapping[selectedDate1] ? dateSlotMapping[selectedDate1].some(el => el.key === selectedTimeSlot1) : false
                    if (!isSlotAvailable1){
                        setSlotErrorText('We regret to inform you that the selected slots have exhausted, please click on slot preference edit icon to select available slots')
                        setSlotsAvailable(false);
                        setLoading(false);
                    } else {
                         if(isCopayRequired) {
                          if(isCopayAfterSr(router)){
                            changeProgress(9)
                            setLoading(false);
                          }
                          else{
                            creatSR(9);
                          }
                        } else {
                            creatSR();
                        }
                    }
                }
            }, (err) => {
                let errData = err.data
                if(isCopayRequired) {
                    creatSR(9);
                } else {
                  if(isCopayRequired) {
                    if(isCopayAfterSr(router)){
                      changeProgress(9)
                      setLoading(false);
                    }
                    else{
                        creatSR(9);
                    }
                    } else {
                        creatSR();
                    }
                }
            })
        } else {
            if(isCopayRequired){
                if(['Self-Repair'].includes(props.selfserveReducer.appointmentProcessType.processType) || isCopayAfterSr(router)){
                    dispatch(changeProgress(9));
                    setLoading(false);
                } else {
                    creatSR(9);
                }
            }else {
                creatSR();
            }
        }
        confirmDetails(); //gtm tracking event
    }

    const selectedCover = props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0]
    const isCopayPlan = props.selfserveReducer.planDetails.is_copay;
    const ticketList = props.selfserveReducer.ticket_list
    const getProblemsList =(serviceRequests:any)=> {
        const customIssue = serviceRequests[0]?.custom_issue || ''
        const problems = customIssue === '' ? serviceRequests[0].selected_problems : [...serviceRequests[0].selected_problems, customIssue]
        return problems
    }

    const getDeviceName = (osid) => {
      let deviceName = ""

      if (ticketList[osid].deviceDetails.hasOwnProperty('category_type')) {
        deviceName = ticketList[osid].deviceDetails.device_name ? `${ticketList[osid].deviceDetails.device_name} (${ticketList[osid].deviceDetails.category_type})` : ticketList[osid].deviceDetails.category_type
      } else {
        deviceName = ticketList[osid].planDetails.category_type
      }

      return deviceName;
    }

    const getCategoryText = (osid) => {
      let category_text = ticketList[osid].deviceDetails?.category ? ticketList[osid].deviceDetails.category : ticketList[osid].planDetails.category;
      if (category_text === getDeviceName(osid)) {
        return '';
      } else {
        return category_text;
      }
    }

    const removeDevice =(osid) =>{
        setDeleteDeviceKey(osid)
        setIsOpenDeviceDeleteModel(!isOpenDeviceDeleteModel)
    }
    // copay reuirement is also depends on the plan name from now onwards
    const isCopayRequired = isCopaymentRequired(isCopayPlan, selectedCover.reopen, 
                                                selectedCover.cover_title, 
                                                props.selfserveReducer.planDetails.plan_name,
                                                selectedCover.is_cover_copay);
    const files = props.selfserveReducer.uploadedDocuments
    return (
      <div className={styles.confirm_parent}>
        <EraseSRListAlert is_open={showAlert} setEnableModal={toggleAlert} router={router}/>
        <div className={commonStyles.top_heading}>
          <h5>Confirm the Service Request Details</h5>
        </div>
        <div className={`${styles.heading_wrapper} ${styles.card_details} ${styles.borderless} ${styles.no_padding}`}>
            <div className={`${styles.sr_confirmation_section__single}`}>
              <div>
                <h6 className={styles.heading_large}>{props.selfserveReducer.planDetails.parent_plan_name ? props.selfserveReducer.planDetails.parent_plan_name : props.selfserveReducer.planDetails.plan_name}<a className={styles.device_selection__edit} onClick={() => {toggleAlert(true)}} href="#" title="Edit selection"></a></h6>
              </div>
            </div>

          <div className={styles.custom_card}>
            {/* Personal Details Section */}
            <div className={`${styles.sr_confirmation_section__single} ${styles.section__left} ${['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType) ? null: styles.section__bottom}`}>
                <h6 className={styles.heading_small}>Personal Details</h6>
                <p className={styles.details}>{props.selfserveReducer.planDetails.order.name}</p>
                <p className={styles.details}>{props.selfserveReducer.planDetails.order.phone}</p>
                <p className={styles.details}>{props.selfserveReducer.planDetails.order.email}</p>
            </div>
            {/* Address Section */}
            <div className={`${styles.sr_confirmation_section__single} ${styles.section__right} ${styles.section__bottom}`}>
                <h6 className={styles.heading_small}>Address Information<a className={styles.device_selection__edit} onClick={() => {handleEditOption(7)}} href="#" title="Edit selection"></a></h6>
                {props.selfserveReducer.customerDetails.address.address2 !== '' ? <p className={styles.details}>{props.selfserveReducer.customerDetails.address.address}, {props.selfserveReducer.customerDetails.address.address2},</p> : <p className={styles.details}>{props.selfserveReducer.customerDetails.address.address},</p>}
                <p className={styles.details}>{`${props.selfserveReducer.customerDetails.address.city}, ${props.selfserveReducer.customerDetails.address.state}-${props.selfserveReducer.customerDetails.address.pincode}`}</p>
            </div>
          </div>
          {/* Slot-Adress Section */}
          <div className={styles.custom_card}>
            {(['AMC'].includes(props.selfserveReducer.appointmentProcessType.processType) && props.selfserveReducer.appointmentProcessType.appointmentDate1) ?
              <div className={`${styles.sr_confirmation_section__single}`}>
                <React.Fragment>
                  <h6 className={styles.heading_small}>Slot Preference<a className={styles.device_selection__edit} onClick={() => { handleEditOption(7) }} href="#" title="Edit selection"></a></h6>
                  <div className={styles.slot_container}>
                    <p className={styles.details}>Slot 1 : {`${Moment(props.selfserveReducer.appointmentProcessType.appointmentDate1, 'DD/MM/YYYY').format('DD MMM YYYY')}, ${props.selfserveReducer.appointmentProcessType.appointmentTimeSlot1}`}</p>
                  </div>
                </React.Fragment> 
            </div>
              : null
              }
            {
              isCopayRequired ?
              (
                <div className={`${styles.heading_wrapper} col-12 col-md-6 col-lg-6`}>
                  <p className={styles.copay_details}>* Copayment is still pending.</p>
                </div>
              ) : null
            }
          </div>
        </div>

        {/* upload documens Section */}
        {props.selfserveReducer.uploadedDocuments.length>0 && <div className={`${styles.heading_wrapper} ${styles.card_details} ${styles.borderless} ${styles.no_padding}`}>
          <div className={`${styles.sr_confirmation_section__single}`}>
            <div>
              <h6 className={styles.heading_small_mob}>{'Uploaded Documents'}<a className={styles.device_selection__edit} onClick={() => {handleEditOption(19)}} href="#" title="Edit selection"></a></h6>
            </div>
          </div>
          {/* Slot-Adress Section */}
          <div className={styles.custom_card}>
            <div className={`${styles.sr_confirmation_section__single}`}>
            {/* Uploaded Documents */}
              <div className={styles.uploadFile}>
              {files.length === 1 && <File file={files[0]}  isLoading={loading} files={files} />}
              {files.length >= 2 &&
                <>
                  <File file={files[0]}  isLoading={loading} files={files} />
                  <File file={files[files.length - 1]} count={files.length} isLoading={loading} files={files} />
                </>
              }
              </div>
            </div>
          </div>
        </div>}

        <h6 className={`${styles.heading_large}`}>Selected Devices: </h6>

        {
          Object.keys(ticketList).map((osid,index)=>{
            return(
              <div key={`ticketList-${index}`} className={`${styles.heading_wrapper} ${styles.card_details} ${styles.borderless} ${styles.no_padding}`}>
                {/* Device Details Section */}
                <div className={`${styles.heading_wrapper} ${styles.device_section} ${styles.device_card}`}>
                  <p className={`${styles.heading}`}>
                    {getDeviceName(osid)}
                    {HOMECARE_PLAN_LIST.includes(ticketList[osid].planDetails?.plan_name) && <a className={`${styles.delete_device} ${styles.confirm_details}`} onClick={() => {removeDevice(osid)}} href="#" title="Edit selection"></a>}
                  </p>
                  <p className={`${styles.details} ${styles.faded}`}>
                    {ticketList[osid].deviceDetails.brand ? `${ticketList[osid].deviceDetails.brand} ` : ''}{getCategoryText(osid)}
                  </p>
                </div>
                {/* Issues Section */}
                <div className={styles.plan_section}>
                  <div className={styles.custom_card}>
                    <div className={`${styles.sr_confirmation_section__single} ${styles.section__left} ${styles.section__bottom}`}>
                      <div>
                        <h6 className={`${styles.details} ${styles.details_large}`}>
                          Selected Cover {!(ticketList[osid].landed_on_page === 'address') && !(ticketList[osid].addressPageFrom === 3)
                            ? <a className={styles.device_selection__edit} onClick={() => {handleEditOption(4,osid)}} href="#" title="Edit selection"></a>
                            : null}
                        </h6>
                        <p key = {`problemList-${index}`} className={`${styles.details} ${styles.faded}`}>{ticketList[osid].serviceRequests[0].selected_cover.cover_details[0].cover_title}</p>
                      </div>
                    </div>
                    <div className={`${styles.sr_confirmation_section__single} ${styles.section__right} ${styles.section__bottom}`}>
                      <h6 className={`${styles.details} ${styles.details_large}`}>
                        Issues Selected {!(props.selfserveReducer.landed_on_page === 'address') && !(props.selfserveReducer.addressPageFrom === 3) && !(ticketList[osid].serviceRequests[0].selected_cover.cover_details[0].type === "service")
                          ? <a className={styles.device_selection__edit} onClick={() => {handleEditOption(5,osid)}} href="#" title="Edit selection"></a>
                          : null}
                      </h6>
                      {getProblemsList(ticketList[osid].serviceRequests) && getProblemsList(ticketList[osid].serviceRequests).map((item,index)=>{
                        return <p key = {`problemList-${index}`} className={`${styles.details} ${styles.faded}`}>{item}</p>
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
        {props.selfserveReducer.planDetails.can_opt_in_whatsapp &&
            <div className={styles.whatsapp_check}>
                <Checkbox name="whatsappCheck" id="whatsapp" onChange={() => { handleWhatsapp() }} checked={whatsappOptIn} />
                <label htmlFor="whatsapp">I agree to recieve updates on my <span></span>WhatsApp.</label>
            </div>
        }
        {slotErrorText &&
            <div className={`${styles.slot_error}`}>
                <p className={styles.error_detail}>{slotErrorText}</p>
            </div>
        }
        {isOpenDeviceDeleteModel &&
            <ConfirmDeleteDeviceModel
                is_open={isOpenDeviceDeleteModel}
                setEnableModal={setIsOpenDeviceDeleteModel}
                deviceKey={deleteDeviceKey}
            />
        }
        <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
          {/* PREVIOUS BUTTON */}
          <Button
              disabled={false}
              className={(isCopayRequired) ? commonStyles.no_padding : commonStyles.cart_btn}
              text={'Discard'}
              variant='secondary'
              onClick={() => {
                  router.reload()
              }}
          />

          <Button
              disabled={!slotsAvailable || loading}
              className={(isCopayRequired) ? commonStyles.no_padding : commonStyles.cart_btn}
              text={(isCopayRequired) ? isCopayAfterSr(router) ? "Next": 'Make Payment' : "Submit"}
              variant='primary'
              onClick={(e) => {handleButton(e)}}
          />
        </div>
      </div>
  )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(ConfirmSrDetails);
